

























































































































































import { Component, Vue } from "vue-property-decorator";
import ConfirmModal from "@/views/company_directory/ConfirmModal.vue";
import EditCompany from "@/views/super_admin/company/EditCompany.vue";
import { Company } from "@/api";

@Component({
  watch: {
    $route() {
      this.$store.dispatch(
        "superAdmin/selectCompany",
        this.$route.params.companyid,
      );
    },
  },
  components: {
    ConfirmModal,
    EditCompany,
  },
})
export default class CompanyDetail extends Vue {
  count = 0;
  companyId = "";
  delteConfirmation = false;
  updateCompany = false;
  deleting = false;
  expirationModal = false;
  showDatePicker = false;
  selectedExpiryDate = "";
  savingExpiry = false;

  get selectedCompany(): Company | null {
    return this.$store.getters["superAdmin/selectedCompany"];
  }

  openExpirationModal() {
    const currentExpiry = this.selectedCompany?.expiresAt;
    if (currentExpiry && !isNaN(new Date(currentExpiry).getTime())) {
      this.selectedExpiryDate = new Date(currentExpiry)
        .toISOString()
        .substring(0, 10);
    } else {
      this.selectedExpiryDate = "";
    }
    this.expirationModal = true;
  }

  closeExpirationModal() {
    this.expirationModal = false;
  }

  async saveExpiration() {
    if (!this.selectedCompany?.id) return;
    this.savingExpiry = true;
    try {
      const expiresAt =
        this.selectedExpiryDate &&
        !isNaN(new Date(this.selectedExpiryDate).getTime())
          ? new Date(this.selectedExpiryDate).toISOString()
          : undefined;
      await this.$store.dispatch("company/setExpiration", {
        companyId: this.selectedCompany.id,
        expiresAt,
      });
      await this.$store.dispatch(
        "superAdmin/selectCompany",
        this.selectedCompany.id,
      );
      this.expirationModal = false;
    } catch (error) {
      console.error(error);
    } finally {
      this.savingExpiry = false;
    }
  }

  async deleteCompany() {
    if (!this.selectedCompany?.id) return;
    this.delteConfirmation = !this.delteConfirmation;
    this.deleting = true;
    await this.$store.dispatch(
      "superAdmin/deleteCompany",
      this.selectedCompany.id,
    );
    this.deleting = false;
    this.$router.push({ path: "/company-list" });
  }

  backToList() {
    this.$router.push({ path: "/company-list" });
  }
}
